import React from "react";
import { LIST } from "./listStyle";

// Web components for three backend modal types that neither the phone nor the
// website rendered before. The backend sends little for them, so each shows
// exactly what it sends, and closing returns to chat ready for input.
//   viewChecklist       CheckLister "show my checklist": data = the items.
//   educationResources  EducationX "online courses": a message (and links in
//                       data, if the backend ever sends them).
//   safetyContacts      DigitHer "notify my contacts / the authorities": a
//                       question; the actions hand off to the DigitHer need form.
// Shell mirrors ScheduleModalWeb.

function Shell({ onClose, title, children }) {
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 9750, background: "rgba(0,0,0,0.85)", display: "flex", alignItems: "center", justifyContent: "center", padding: "16px" }}
      onClick={onClose}>
      <div role="dialog" aria-label={title}
        style={{ background: "#fff", borderRadius: "14px", width: "min(520px,100%)", maxHeight: "90vh", overflow: "auto", padding: "20px", display: "flex", flexDirection: "column", gap: "14px", position: "relative" }}
        onClick={(e) => e.stopPropagation()}>
        <button type="button" onClick={onClose} aria-label="Close"
          style={{ position: "absolute", top: "12px", right: "12px", border: "none", background: "transparent", fontSize: "20px", cursor: "pointer", color: "#666" }}>✕</button>
        <div style={{ fontWeight: 800, fontSize: "17px", marginRight: "24px" }}>{title}</div>
        {children}
      </div>
    </div>
  );
}

const doneButton = (onClose, label = "Done") => (
  <button type="button" onClick={onClose}
    style={{ alignSelf: "center", padding: "12px 32px", background: "blue", color: "#fff", border: "none", borderRadius: "10px", fontWeight: 600, cursor: "pointer" }}>
    {label}
  </button>
);

export function ViewChecklistWeb({ open, message, items = [], onClose }) {
  if (!open) return null;
  const nameOf = (it) => it?.itemName || it?.name || it?.item || it?.task || "";
  const dateOf = (it) => (it?.dateAdded ? String(it.dateAdded).slice(0, 10) : "");
  return (
    <Shell onClose={onClose} title="My checklist">
      {message && <p style={{ margin: 0, color: "#333", fontSize: "14px" }}>{message}</p>}
      <ul style={LIST.list}>
        {items.map((it, i) => (
          <li key={it?._id || i} style={LIST.row}>
            <span style={{ fontSize: "16px" }}>☐</span>
            <span style={{ flex: 1 }}>{nameOf(it) || "(unnamed item)"}</span>
            {dateOf(it) && <span style={{ color: "#888", fontSize: "12px" }}>{dateOf(it)}</span>}
          </li>
        ))}
      </ul>
      <p style={{ margin: 0, color: "#777", fontSize: "12px" }}>Say "add item to my checklist" or "remove from my checklist" to change it.</p>
      {doneButton(onClose)}
    </Shell>
  );
}

export function EducationResourcesWeb({ open, message, links = [], onClose }) {
  if (!open) return null;
  const list = (Array.isArray(links) ? links : []).map((l) => (typeof l === "string" ? { url: l, title: l } : l)).filter((l) => l && l.url);
  return (
    <Shell onClose={onClose} title="Learning resources">
      <p style={{ margin: 0, color: "#333", fontSize: "14px", whiteSpace: "pre-line" }}>{message}</p>
      {list.length > 0 && (
        <ul style={{ margin: 0, paddingLeft: "18px", display: "flex", flexDirection: "column", gap: "6px" }}>
          {list.map((l, i) => <li key={i}><a href={l.url} target="_blank" rel="noopener noreferrer">{l.title || l.url}</a></li>)}
        </ul>
      )}
      <p style={{ margin: 0, color: "#777", fontSize: "12px" }}>Say "I need study materials" for resources on a topic, or post an Education need for a tutor.</p>
      {doneButton(onClose)}
    </Shell>
  );
}

export function SafetyContactsWeb({ open, message, onNotifyContacts, onClose }) {
  if (!open) return null;
  return (
    <Shell onClose={onClose} title="Get help">
      <p style={{ margin: 0, color: "#333", fontSize: "14px" }}>{message || "Who would you like to notify about your situation?"}</p>
      <button type="button" onClick={onNotifyContacts}
        style={{ padding: "12px", background: "#fff", border: "1.5px solid blue", color: "blue", borderRadius: "10px", fontWeight: 600, cursor: "pointer" }}>
        My trusted contacts and the DigitHer community
      </button>
      <div style={{ padding: "12px", background: "#fff4f4", border: "1px solid #f3c2c2", borderRadius: "10px", fontSize: "14px", color: "#8a1f1f" }}>
        <b>The authorities:</b> if you are in immediate danger, call your local emergency number now. This website cannot place the call for you.
      </div>
      {doneButton(onClose, "Close")}
    </Shell>
  );
}
